import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    userInfo: {}
};

export const callTypes = {
    list: "list",
    action: "action"
};

export const userProfileRewardTransaction = createSlice({

    name: "userProfileRewardTransaction",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        listFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        singleNameFetched: (state, action) => {
            state.actionsLoading = false;
            state.userInfo = action.payload?.userInfo;
            state.error = null;
        },
        emptyList: (state, action) => {
            state.error = null;
            state.entities = [];
        },
    }
})